// const source = 'podsDataTable'

function DialogcreaCliente () {
  this.$eventBus.emit('show-dialog-page', {
    page: 'DialogcreaCliente',
    title: 'Crea Nuovo Cliente',
    data: {},
    maximize: false,
    buttonOk: {
      label: 'Esegui',
      icon: 'pi pi-check',
      class: '',
      visible: true,
      disabled: false,
    },
    buttonCancel: {
      label: 'Annulla',
      icon: 'pi pi-times',
      class: 'p-button-text',
      visible: true,
      disabled: false,
    },
  })
}

export default {
  'bindTo': 'this',
  'method': DialogcreaCliente,
}
